var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.40625V10.0312H8.25C8.59375 10.0312 8.75 10.4375 8.53125 10.6562L6.28125 12.9062C6.125 13.0625 5.84375 13.0625 5.6875 12.9062L3.4375 10.6562C3.21875 10.4375 3.375 10.0312 3.71875 10.0312H5.25V7.40625C5.25 7.1875 5.40625 7.03125 5.625 7.03125H6.375C6.5625 7.03125 6.75 7.1875 6.75 7.40625ZM11.5312 3.0625C11.8125 3.34375 12 3.75 12 4.125V14.5312C12 15.3438 11.3125 16 10.4688 16H1.46875C0.65625 16 0 15.3438 0 14.5312V1.53125C0 0.6875 0.65625 0.03125 1.46875 0H7.875C8.25 0 8.625 0.1875 8.90625 0.46875L11.5312 3.0625ZM7.96875 1.625V4.03125H10.375L7.96875 1.625ZM10.5 14.5312V5.53125H7.21875C6.8125 5.53125 6.46875 5.1875 6.46875 4.78125V1.53125H1.46875V14.5312H10.5Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c959e76c.svg";
export { ForwardRef as ReactComponent };